module.exports = __webpack_public_path__ + "static/media/w1.900572e1.jpg";